import { render, staticRenderFns } from "./company-fund-chart.vue?vue&type=template&id=5898acee&scoped=true"
import script from "./company-fund-chart.vue?vue&type=script&lang=js"
export * from "./company-fund-chart.vue?vue&type=script&lang=js"
import style0 from "./company-fund-chart.vue?vue&type=style&index=0&id=5898acee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5898acee",
  null
  
)

export default component.exports